/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbLabel } from "abreact/incubator/ui/component/AbLabel";
import { AbLoginHeader } from "abreact/incubator/ui/login/AbLogin";
import { AbPopup } from "abreact/incubator/ui/popup/AbPopup";
import { AbPopupContext } from "abreact/incubator/ui/popup/PopupContext";
import { AbVBox } from "abreact/layout/AbVBox";
import { AbButton, AbButtonType } from "abreact/misc/AbButton";
import { PopupManager } from "abreact/popup/PopupManager";
import { AbReactServices } from "abreact/service/AbReactServices";
import { AbWebServices } from "abweb/service/AbWebServices";
import { KeyValue } from "abweb/utils/KeyboardUtils";
import * as React from "react";
export function AbAccessDeniedDialog() {
  const popupContext = React.useContext(AbPopupContext);
  const logout = async () => {
    await AbWebServices.authenticationService.logout();
    return true;
  };
  const onKeyPress = event => {
    if (event.key === KeyValue.ENTER) {
      popupContext?.popupHandle.close();
    }
    return true;
  };
  return /*#__PURE__*/React.createElement(AbPopup, {
    className: "ab-access-denied-dialog ab-product-login",
    onKeyPress: onKeyPress,
    resizable: false,
    onClose: logout
  }, /*#__PURE__*/React.createElement(AbVBox, {
    spacing: true
  }, /*#__PURE__*/React.createElement(AbLoginHeader, {
    suppressProductName: !AbReactServices.bannerProvider.productNameSupported
  }), /*#__PURE__*/React.createElement(AbLabel, {
    className: "ab-access-denied-message",
    label: AbReactResources.accessDeniedDialog_message(),
    wrapText: true
  }), /*#__PURE__*/React.createElement(AbButton, {
    label: AbReactResources.accessDeniedDialog_logOut(),
    onClick: logout,
    type: AbButtonType.PRIMARY,
    className: "ab-access-denied-button"
  })));
}
(function (_AbAccessDeniedDialog) {
  const showAccessDeniedDialog = _AbAccessDeniedDialog.showAccessDeniedDialog = async () => {
    await PopupManager.show(/*#__PURE__*/React.createElement(AbAccessDeniedDialog, null)).untilClosed;
  };
})(AbAccessDeniedDialog || (AbAccessDeniedDialog = {})); // @observer
// export class AbAccessDeniedDialog extends BaseRCmp<IPopupContext>
// {
//   public static async showAccessDeniedDialog(): Promise<void>
//   {
//
//   }
//
//   render(): React.ReactNode
//   {
//     return (
//         <AbDialog className="ab-access-denied-dialog ab-product-login"
//                   closeButton={false}
//                   onKeyPress={this.onKeyPressed}
//                   buttonBar={this.renderButtonBar()}
//                   resizable={false}
//                   onCancel={this.logout}>
//         </AbDialog>
//     );
//   }
//
//   renderButtonBar(): React.ReactNode
//   {
//     return (
//         <AbDialogButtonBar className="ab-access-denied-buttonbar"
//                            okButton={AbReactResources.accessDeniedDialog_logOut()}
//                            onOk={this.logout}
//                            cancelButton={false}/>
//     );
//   }
//
//   @action.bound
//   private async logout(): Promise<boolean>
//   {
//     await AbWebServices.authenticationService.logout();
//     return true;
//   }
//
//   @action.bound
//   private onKeyPressed(event: React.KeyboardEvent): boolean
//   {
//     if (event.key === KeyValue.ENTER)
//     {
//       this.logout();
//       this.props.popupHandle.close();
//     }
//
//     return true;
//   }
// }
//
// const AbAccessDeniedDialogImpl = withAbPopupContext(AbAccessDeniedDialog);
//# sourceMappingURL=AbAccessDeniedDialog.js.map
